<template>
  <div>
    <LfBlueTitleComponent :title="texts.title" />
    <LfSimpleProgressBarComponent :text="texts.caption" :icon="icon"/>
  </div>
</template>

<script setup lang="ts">

import { onMounted, PropType } from 'vue'
import LfBlueTitleComponent from '@/components/HeaderTitle/LfBlueTitleComponent.vue'
import { IFacturaEDialogModel } from '@/components/billing/FacturaEDialog/types/FacturaEDialogTypes'
import useActionsFacturaEDialog from '@/components/billing/FacturaEDialog/composables/useActionsFacturaEDialog'
import { useI18n } from 'vue-i18n-composable'
import LfSimpleProgressBarComponent from '@/components/ProgressBar/LfSimpleProgressBarComponent.vue'

const props = defineProps({
  model: {
    type: Object as PropType<IFacturaEDialogModel>,
    required: true
  }
})
const { t } = useI18n()
const texts = {
  title: t('components.facturae_dialog.validator.title').toString(),
  caption: 'Enviando factura electrónica...',
}

const icon = 'lf-icon-document-validate'

const { send } = useActionsFacturaEDialog(props.model)

onMounted(async () => await send())

</script>

<style scoped lang="scss">
.step-wizard-container {
  width: 100%;

  .step-title {
    @include milano-bold-18;
    color: $main-1000;
  }

  .step-instructions {
    @include milano-regular-14;
    color: $neutral-grey-800;
    margin-top: $spacing-xs;
  }

  .static-alert {
    margin-top: $spacing-md;
  }
}
</style>
